import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RichText from 'legacy-src/utility/RichText';
import { optionalSubmittable } from '../shared/survey';
import './text_response.scss';

class Player extends Component {
  render() {
    const {
      item: { content },
      submission,
      defaultSize,
    } = this.props;
    const { submitted, selection } = submission.state;
    const size = content.size ? content.size : defaultSize;
    const setProps = {
      disabled: submitted,
      valueLink: {
        value: selection,
        requestChange(selection) {
          submission.setState({ selection });
        },
      },
    };
    return (
      <div className="survey_question">
        <div className="survey_text_response">
          <RichText className="" content={content.question} />
          <div className="">
            <textarea rows={size.rows} cols={size.cols} {...setProps} />
          </div>
        </div>
      </div>
    );
  }
}

Player.displayName = 'TextResponse';

Player.propTypes = {
  item: PropTypes.object,
  submission: PropTypes.object,
  defaultSize: PropTypes.object,
};

Player.defaultProps = {
  defaultSize: {
    rows: 5,
    cols: 45,
  },
};

export default { Player, status: optionalSubmittable };
